export const proponentsOptionsLabel = [
  {
    value: 'PROFIT',
    label: 'PROFIT',
    name: 'Profit',
  },
  {
    value: 'NOPROFIT',
    label: 'NO PROFIT',
    name: 'No Profit',
  },
  {
    value: 'ET',
    label: 'ENTI TERRITORIALI',
    name: 'Enti Territoriali',
  },
  {
    value: 'ECCL',
    label: 'PARROCCHIE',
    name: 'Parrocchie',
  },
  {
    value: 'UNI',
    label: 'UNIVERSITÀ E CUS',
    name: 'Università e Cus',
  },
  {
    value: 'AUD',
    label: 'AUDIOVISIVI',
    name: 'Audiovisivi',
  },
  {
    value: 'portfolio',
    label: 'PORTAFOGLIO',
    name: 'Portafoglio',
  },
  {
    value: 'LIGHTNOPRO',
    label: 'NO PROFIT LIGHT',
    name: 'No Profit Light',
  },
  {
    value: 'LIGHTPRO',
    label: 'PROFIT LIGHT',
    name: 'Profit Light',
  },
];
